import Swiper, { Pagination, Manipulation } from "swiper";
import { initIntersectionObserver, MatchHeight } from "@plugins";

const comparisonModels = document.querySelector(".js-comparison-models-slider");

if (comparisonModels) {
    if (window.mobileMedia) {
        initIntersectionObserver(comparisonModels, initComparisonModelsSlider);
    } else {
        window.addEventListener("load", () => initTitleMatchHeight());
    }
}

function initComparisonModelsSlider(swiper) {
    new Swiper(swiper, {
        modules: [Pagination, Manipulation],
        slidesPerView: 1.2,
        spaceBetween: 16,
        preventClicks: false,

        pagination: {
            el: ".js-comparison-models-controls .swiper-pagination",
            dynamicBullets: true,
            dynamicMainBullets: 3,
            clickable: true,
            type: "progressbar",
        },

        observer: true,
        observeParents: true,
        watchOverflow: true,

        breakpoints: {
            400: {
                slidesPerView: 1.3,
            },
            450: {
                slidesPerView: 1.4,
            },
            500: {
                slidesPerView: 1.6,
            },
            550: {
                slidesPerView: 1.8,
            },
            600: {
                slidesPerView: 2,
            },
            650: {
                slidesPerView: 2.5,
            },
        },
    });

    initTitleMatchHeight();
}

function initTitleMatchHeight() {
    const neededSelectors = [".comparison-models-card__type-and-title"];

    for (const iterator of neededSelectors) {
        new MatchHeight(iterator);
    }
}
